// Money helpers — everything is stored/passed as integer cents.

// Default currency when a receipt doesn't specify one (Moroccan Dirham).
export const DEFAULT_CURRENCY = "MAD";

export function formatMoney(cents: number, currency = DEFAULT_CURRENCY): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

// Parse a user-typed amount like "12.34" into integer cents.
export function centsFromInput(value: string | number): number {
  const n = typeof value === "number" ? value : parseFloat(value);
  if (!isFinite(n)) return 0;
  return Math.round(n * 100);
}

// Integer cents -> editable string like "12.34".
export function inputFromCents(cents: number): string {
  return (cents / 100).toFixed(2);
}
